import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import translations from '../i18n/index';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    // Check localStorage first, then default to 'en'
    return localStorage.getItem('language') || 'en';
  });

  useEffect(() => {
    localStorage.setItem('language', language);
    document.documentElement.lang = language;
  }, [language]);

  // Sync language from user profile when auth loads
  const syncLanguage = useCallback((userLanguage) => {
    if (userLanguage && userLanguage !== language) {
      setLanguage(userLanguage);
    }
  }, [language]);

  const t = useCallback((key) => {
    const translation = translations[language]?.[key];
    if (translation !== undefined) return translation;
    // Fallback to English
    const fallback = translations['en']?.[key];
    if (fallback !== undefined) return fallback;
    // Return key if not found
    return key;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, syncLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useTranslation must be used within a LanguageProvider');
  }
  return context;
};

export default LanguageContext;